// Core
import React from "react";
import { Editor } from "react-draft-wysiwyg";
// import { EditorState, convertToRaw, ContentState } from "draft-js";
// import draftToHtml from "draftjs-to-html";
// import htmlToDraft from "html-to-draftjs";
// import FlatButton from "material-ui/FlatButton";

// Instruments
import options from './options';

// Styles & assets
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// import './styles.css';

// const saveStyle = {
//   position: "fixed",
//   bottom: "50px",
//   right: "50px",
//   background: "#6da92e",
//   color: "#fff",
//   zIndex: 1000000,
// };

// TODO: move editorState to Redux
class RichTextEditor extends React.Component {
  // constructor(props) {
  //   super();
  // const text = props.text;

  // const editorState = stringToEditorObj(text);
  // this.state = {
  //   editorState
  // };

  //   options.image.uploadCallback = async (file) => {
  //       console.log(file)
  //       const result = await props.onUpload(file, file.name)
  //       console.log(result)
  //       return { data: { link: result.url}}
  //   }
  // }

  // static getDerivedStateFromProps(props, state) {
  //   return { ...state, editorState: stringToEditorObj(props.text) };
  // }

  // onEditorStateChange = editorState => {
  //   this.setState({
  //     editorState
  //   });
  // };

  // onSave = () => {
  //     const { editorState } = this.state;
  //     const { onSave } = this.props;
  //     const html = draftToHtml(
  //         convertToRaw(editorState.getCurrentContent())
  //     ) + '';
  //     onSave(html)
  // }

  render() {
    const { editorState, handleChangeEditorState } = this.props;
    // console.log(editorState.toJS(), 'editorState')

    return (
      // <div className="wrap-templates-editor">
        <Editor
          toolbar={options}
          editorState={editorState}
          onEditorStateChange={handleChangeEditorState}
          placeholder="Description (optional)"
          wrapperClassName="wrapper-class"
          editorClassName="editor-class"
          toolbarClassName="toolbar-class"
          editorStyle={{
            border: '1px solid lightgrey',
            minHeight: '120px',
            padding: '0 5px',
            maxHeight: 300
          }}
        />
        // {/* <FlatButton
        //   label="Save"
        //   onClick={this.onSave}
        //   backgroundColor="#6da92e"
        //   hoverColor="#7bd023"
        //   style={saveStyle}
        // /> */}
      // </div>
    );
  }
}

export default RichTextEditor;
